import React, { useState, useContext, useEffect } from 'react';
import { useLocation } from "react-router-dom";
import { ITextSelectionInformation, IPickerProperties, IElement, IArtboardZIndexChain, IEditorStatus, IAddInsStatus, IAddInRotationStatus, IUndoRedoCommand, IProviderProps, IContextProps, IToolType, IGroupStatus, IPickerType, IExportingProperties, IExportingSize, IExportingRatio, IWarningStatus, ISubPickerType,ISubPickerProperties, ICommandInformation, IEntityInformation, IGridOverlay, ISave, ISaveStatus} from './types';
import { ISelectDescribeData, ITaggedField, ITemplateFields, IDraggingData } from './types';
import { IClipBoardElement } from './types';
import { ITemplate, Preview } from '../../../state/templates/types';
import { IDesign, PermissionEnum } from '../../../state/designs/types';
import { IParsedTree, IParsedTreeChange } from '../../../state/parsedTrees/types';
import { IUserFiles } from '@state/userFiles/types';
import { UpdateElementsInfo, IUpdateFieldInfo, IUpdateFieldTagsInfo, IUpdateFieldsTagsInfo, IUpdateTemplateFieldsInfo} from '../../../state/parsedTrees/types';
import {resolver} from './resolver';
import { findElementById, updateElement, prepareArtboardForClipBoard, prepareSetForClipBoard } from '@utils/editor';
import { getTaggedElementsId, getTaggedVisibleElementsId, getCategoryElementTagged, getCategoryType, FindNextNumber, getSelectDescribeCopyPaste, revomeFromSelectAndDescribe, getSelectDescribeCopyPasteArtboardChild, getDeepestElements} from '@utils/selectDescribe';
import { useDispatch } from 'react-redux';
import actions from '@state/actions';
import { AuthContext } from '@utils/DOIgnition/AuthContext';
import Konva from 'konva';
import { cloneDeep, set } from 'lodash';
import { IDSConfig, IField, IMultiEditingConfig } from '@state/dsconfig/types';
import { prepareElementForClipBoard, prepareClipBoardForReCopy, getParentElement, findArtboardIndex } from '@utils/editor';
import { ICopyPasteCommandValue } from './Editor/CommandsBars/MainCommandBar/CommandsOptions/CopyPasteCommandOption/types';
import selectors from '@state/selectors';
import { useSelector } from 'react-redux';
import { getMultiEditingForTemplate } from 'utils/multiEditing'
import { updateArtboardsZIndexChain, getArtboardZIndexChain } from '@utils/zIndexChains';
import { IResizeValues } from './Editor/CommonCommandsOptions/ResizeCommandOption/types'
import { otherElementHasColor } from '@utils/colors';
import { storageAccountName, containerName } from '@storage/azure-storage-blob';

const defaultGridOverlay: IGridOverlay={
    show:false,
    size:undefined
}

const defaultSaveStatus: ISaveStatus={
    savingParsedTree: false,
    saveVersion: true,
    updatingSelectDescribeTaggedElements: false,
    showSavingStatus :false
}

const defaultEditorStatus: IEditorStatus = {
    selectedElementsId: [],
    selectedArtboardIds: [],
    showSelectDescribe: false,
    showDescribedLayerColor: false,
    currentPicker: "MultiEditing",
    pickerProperties: undefined,
    isPickerFocused: false,
    currentSubPicker: undefined,
    subPickerProperties: undefined,
    showCropImage: false,
    beforeCroppedImage: {},
    selectorActive: "off",
    zoom: { value: 100, point: 'center'},
    dragging: false,
    draggingNewElement: false,
    commandOptions: [],
    isShiftPressed: false,
    groupsStatus: [],
    clipBoard: [],
    exporting:false,
    exportingProperties:undefined,
    exportingSizes:[],
    currentVersion:undefined,
    selectedVersion: undefined,
    editMode:true,
    sharing:false,
    setsSelected:undefined,
    gridOverlay:defaultGridOverlay
    // TODO other default options and values
};



const defaultAddInRotationStatus: IAddInRotationStatus = {
    visible: false
};

const defaultAddInsStatus: IAddInsStatus = {
    addInRotationStatus: defaultAddInRotationStatus
};

const defaultWarningStatus: IWarningStatus = {
    showWarningScreen: false, 
    warningOptions: {
        title: "",
        subtitle: "",
        actionTitle: "",
        actionFunction: undefined,
        closeActionTitle: "",
        errorNote: "",
        errorArguments: []
    }
};



// Create Context and initially with dummy values
export const Context = React.createContext<IContextProps>({
    stageRef: {current: null},
    userPermission: PermissionEnum.VIEW,
    entityInformation: {id: ""} as ITemplate,
    parsedTreeInfo: {id: ""} as IParsedTree,
    userFiles: {id: ""} as IUserFiles,
    data: [],
    artboardsZIndexChain: [],
    colorPalette: [],
    selectDescribe: undefined,
    dataUndo: [],
    dataRedo: [],
    multiEditingConfig: undefined,
    editorStatus: defaultEditorStatus,
    saveStatus: defaultSaveStatus,
    addInsStatus: defaultAddInsStatus,
    warningStatus: defaultWarningStatus,
    selectorActive: "off",
    searchImages: false,
    onEditEntityInformation: (entityInfo: ITemplate) => undefined,
    onEditUserFiles: (userFiles: IUserFiles) => undefined,
    onEditUserFilesClose: (userFiles: IUserFiles) => undefined,
    onShowSelectDescribe: (show: boolean) => undefined,
    onShowDescribedLayerColor: (show: boolean) => undefined,
    onShowPicker: (picker: IPickerType, pickerProperties?: IPickerProperties) => undefined,
    onIsPickerFocued: (value: boolean) => undefined,
    onShowSearchImages: (show: boolean) => undefined,
    onShowSubPicker: (subpicker: ISubPickerType, subPickerProperties?: ISubPickerProperties, selectDescribeFieldId?: string[]) => undefined,
    onSavingParsedTree: (saving: boolean) => undefined,
    onSelectedElementsIdChange: (id?: string) => undefined,
    onMultiEditingFocus: (selectDescribeFieldId: string[]) => undefined,
    onGroupOpenStatusChange: (id: string) => undefined,
    onWarningScreenChange: (open: boolean, title: string, subtitle: string, actionTitle: string, actionFunction: any, closeActionTitle: string, errorNote: string, errorArguments: any, secondaryFunction?: any) => undefined,
    onSelectedSelectDescribeCategoryIdChange: (id?: string) => undefined,
    onSelectDescribeCategoryClearAll: (id: string) => undefined,
    onSelectDescribeCategoryAdd: (idCategory: string, categoryName: string) => undefined,
    onSelectedElementIsEditing: (id?: string, isEditing?: boolean, offsetX?:number, offsetY?:number, height?:number) => undefined,
    onSelectedText: (textSelectionInformation: ITextSelectionInformation) => undefined,
    onOverElementIdChange: (id?: string, isOver?: boolean) => undefined,
    onSelectedArtboardChange: (id?: string) => undefined,
    onScrolling: (scrollX?:number, scrollY?:number) => undefined,
    onCommandChange: (command: string, value?: any, ids?: string[], values?: any[], notAutoSave?: boolean, multiEditingMode?: boolean, showSavingMessage?: boolean, commandOrigin?: string) => undefined,
    onColorAdded: (color: string) => undefined,
    onTemplateCategoryAdded: (parentCategoryId: string, parentCategoryName: string) => undefined,
    onTemplateCategoryRemoved: (templateCategoryId: string) => undefined,
    onRotation: (rotation?: number, x?: number, y?: number, offsetX?: number, offsetY?: number) => undefined,
    onHandleShift: (value: boolean) => undefined,
    onShowCropImage: (value: boolean, save?: boolean) => undefined,
    onCancelCropImage: () => undefined,
    onUndoRedo: (value: string) => undefined,
    onSelectorActive: (value: string, ids: string[]) => undefined,
    onExporting: (exporting: boolean, exportingProperties?: IExportingProperties) => undefined,
    onExportingPropsChange: (exportingProperties?: IExportingProperties) => undefined,    
    onExportingCompress: (size?:number, ratio?:number, id?:string) => undefined,
    onZoomChange: (value: number, point?: string) => undefined,
    onDraggingNewElement: (value: boolean) => undefined,
    onDraggingData: (value?: IDraggingData) => undefined,
    onDraggingChange: (value: boolean) => undefined,
    onSavingPreview: (data:string[], name:string, inmediate?: boolean)=> undefined,
    onExportArtboardMedia: (data:string[], dealerId:string, collection:string, prefix:string, access_token:string, name:string, inmediate?: boolean)=> undefined,
    addUpdatePreviews: () => undefined,
    onUpdateEntityInformation: (value: ITemplate|IDesign)=> undefined,
    onSelectVersion: (change: IParsedTreeChange) => undefined,
    onSelectEditMode: (edit:boolean)=> undefined,
    onSelectCurrentVersion: ()=> undefined,
    onRestoreVersion: ()=> undefined,
    onSharing: (sharing: boolean) => undefined,
    onRefreshStage: (refresh: boolean)=> undefined,
    onSetsChange: (set: string) => undefined,
    onShowGridOverlay: (show:boolean)=>undefined,
    onChangeGridOverlaySize: (size:number)=>undefined,
    onSavePending: (savePending:boolean)=> undefined,
    onDeleteUserFiles: (files: string[] | null) => undefined,
    onPasteExternalImage: (file: File) => undefined,
    loadLastExternalImage: (file: File) => undefined,
    onExternalImageLoaded: () => undefined,
    //clearExternalImages: () => undefined,
});

const AddInitGroupsStatus = (data: IElement[], groupsStatus?: IGroupStatus[]): IGroupStatus[] => {
    if (!groupsStatus) {
        groupsStatus = [];
    }
    for(let i=0;i<data.length;i++) {
        if (data[i].type==="Group") {
            groupsStatus.push({groupId: data[i].id, isOpen: true});
        }
        if (data[i].children) {
            groupsStatus = AddInitGroupsStatus(data[i].children!,groupsStatus);
        }
    }
    return groupsStatus;
}

const GetInitEditorStatus = (data: IElement[]):IEditorStatus => {
    let editorStatus = defaultEditorStatus;
    let groupsStatus = AddInitGroupsStatus(data);
    editorStatus.groupsStatus = groupsStatus;
    return editorStatus;
}

// Create Provider
const Provider:React.FC<IProviderProps> = (props) => {
    const [userPermission, setUserPermission] = useState(props.userPermission);
    const [entityInformation, setEntityInformation] = useState<IEntityInformation>(props.entityInformation);
    const [userFiles, setUserFiles] = useState<IUserFiles>(props.userFiles);
    const [parsedTreeInfo, setParsedTreeInfo] = useState<IParsedTree>(props.parsedTree && { ...props.parsedTree, ...{ data: undefined } });
    const [data, setData] = useState<IElement[]>(props.parsedTree?.data ? props.parsedTree?.data : []);
    const [artboardsZIndexChain, setArtboardsZIndexChain] = useState<IArtboardZIndexChain[]>(props.parsedTree?.artboardsZIndexChain ? props.parsedTree?.artboardsZIndexChain : []);
    const [colorPalette, setColorPalette] = useState<string[]>(props.parsedTree?.colorPalette  ? props.parsedTree?.colorPalette : []);
    const [multiEditingConfig, setMultiEditingConfig] = useState<IMultiEditingConfig>();
    const [dataUndo, setDataUndo] = useState<IUndoRedoCommand[][]>([]);
    const [dataRedo, setDataRedo] = useState<IUndoRedoCommand[][]>([]);
    const [selectorActive, setSelectorActive] = useState<string>("off");
    const [searchImages, setSearchImages] = useState<boolean>(false);
    //undoredo per command
    //const [temporaryUndoInfo, setTemporaryUndoInfo] = useState<IUndoRedoCommand[]>([]);
    const [temporaryUndoInfo, setTemporaryUndoInfo] = useState<ICommandInformation|undefined>();
    const [selectDescribe, setSelectDescribe] = useState<ISelectDescribeData>(props.parsedTree?.selectDescribe  ? props.parsedTree?.selectDescribe : {taggedFields:[], templateFields:[]});
    const [editorStatus, setEditorStatus] = useState<IEditorStatus>(defaultEditorStatus);
    const [saveStatus, setSaveStatus] = useState<ISaveStatus>(defaultSaveStatus);
    const [addInsStatus, setAddInsStatus] = useState<IAddInsStatus>(defaultAddInsStatus);
    const [warningStatus, setWarningStatus] = useState<IWarningStatus>(defaultWarningStatus);
    const dsConfig: IDSConfig = useSelector(selectors.dsConfig.getDSConfig);
    const dataArtboardsCountRef= React.useRef<number>(0);

    //const [timer, setTimer] = useState(false);
    const [timerId, setTimerId] = useState<NodeJS.Timeout>();
    const [saveObj, setSaveObj] =  useState<ISave>();

    const [saveObjPending, setSaveObjPending] =  useState<ISave>();
    const updatedElementsResponse = useSelector(selectors.parsedTrees.getUpdatedElementsResponse);
    
    const authContext = useContext(AuthContext)
    let location = useLocation();    


    useEffect( () => {        
        if (saveObj?.save) {
           // timer should start
            if (timerId)
                clearTimeout(timerId);                

            const id =  setTimeout(async ()=>{                                                     
                const userData = {
                    email: authContext?.userData.profile.email ? authContext?.userData.profile.email : "defaultuser@tangocode.com",
                    name: authContext?.userData.profile.name ? authContext?.userData.profile.name : "Default User"
                };

                if (!saveObj.notUpdateEditorStatus) {
                    onSavingParsedTree(true, saveObj.showSavingMessage, editorStatus.selectedElementsId);
                }

                dispatch(actions.parsedTrees.setUpdateParsedTreeElements(undefined));      
                dispatch(actions.parsedTrees.setUpdateParsedTreeTemplateFields(undefined));
                dispatch(actions.parsedTrees.setUpdateParsedTreeFieldsTags(undefined));
                let updateInfo: UpdateElementsInfo = {
                    id: entityInformation.parsedTree, 
                    elements: saveObj.elements??[], 
                    updatedBy: userData, 
                    artboardsZIndexChain: saveObj.updatedArtboardsZIndexChain,
                    templateFields: selectDescribe && selectDescribe.templateFields ? selectDescribe.templateFields:null,
                    fieldsTags: selectDescribe && selectDescribe.templateFields? selectDescribe.taggedFields:null
                }                
                updateParsedTreeElementsInfo(updateInfo , saveObj.saveVersion);
              

            },dsConfig.editorConfig.saveConfig.waitingTime);             
            onSavePending(true);
            setTimerId(id);            
        }     
        return () => {
           // clean up
           if (timerId) {
               clearTimeout(timerId);
           }
        }
      }, [saveObj]); // listen to changes on timer state

/*
useEffect( () => {        
    //if (!updatedElementsResponse && saveObj)
    //{
    if (saveObj?.save) {               
        const userData = {
            email: authContext?.userData.profile.email ? authContext?.userData.profile.email : "defaultuser@tangocode.com",
            name: authContext?.userData.profile.name ? authContext?.userData.profile.name : "Default User"
        };

        //if (!saveObj.notUpdateEditorStatus) {
            onSavingParsedTree(true, saveObj.showSavingMessage, editorStatus.selectedElementsId);
        //}

        dispatch(actions.parsedTrees.setUpdateParsedTreeElements(undefined));      
        dispatch(actions.parsedTrees.setUpdateParsedTreeTemplateFields(undefined));
        dispatch(actions.parsedTrees.setUpdateParsedTreeFieldsTags(undefined));
        let updateInfo: UpdateElementsInfo = {
            id: entityInformation.parsedTree, 
            elements: saveObj.elements??[], 
            updatedBy: userData, 
            artboardsZIndexChain: saveObj.updatedArtboardsZIndexChain,
            templateFields: selectDescribe && selectDescribe.templateFields ? selectDescribe.templateFields:null,
            fieldsTags: selectDescribe && selectDescribe.templateFields? selectDescribe.taggedFields:null
        }                
        updateParsedTreeElementsInfo(updateInfo , saveObj.saveVersion);                  
        onSavePending(true);
    }       
}, [saveObj]); // listen to changes on timer state

      useEffect(()=>{

        if (updatedElementsResponse==200)
        {
            if (saveObjPending)
            {
                setSaveObj(saveObjPending);
                setSaveObjPending(undefined);
            }
            else
                setSaveObj(undefined);
        }                    
      },[updatedElementsResponse])
*/


    useEffect(() => {
        let init = GetInitEditorStatus(data);
        if (location.pathname.includes("template")) init.showSelectDescribe = true;
        if (userPermission !== PermissionEnum.EDIT) init.editMode = false;
        setEditorStatus(init);
    }, [])

    useEffect(() => {
        if(dsConfig && editorStatus.currentPicker === "MultiEditing") {
            setMultiEditingConfig(getMultiEditingForTemplate(dsConfig.editorConfig.multiEditingConfig, data, selectDescribe));
        }
    }, [dsConfig,selectDescribe,editorStatus.currentPicker,editorStatus.showSelectDescribe,editorStatus.setsSelected])

    useEffect(()=>{
        if (props.userFiles?.files) {
            if (userFiles?.files) setUserFiles({...userFiles, files: [...userFiles.files, ...props.userFiles.files]});
            else setUserFiles(props.userFiles);
          }                
    },[props.userFiles])


    useEffect(()=>{
        if (data) {
            if (dataArtboardsCountRef.current>0 && dataArtboardsCountRef.current!==data[0].children?.length) 
                addUpdatePreviews ();
                
            dataArtboardsCountRef.current = data[0].children?.length??0;
        }               
    },[data])

    
    const onShowSelectDescribe = (show: boolean) => {
        setEditorStatus({
            ...editorStatus, 
            showDescribedLayerColor: false,
            selectedElementsId: [],
            editElementId: undefined,
            overElementId: undefined,
            selectedElementIsEditing: false,
            selectedSelectDescribeCategoryId: undefined,
            showSelectDescribe: show
        });
    }

    const onShowDescribedLayerColor = (show: boolean) => {
      setEditorStatus({
          ...editorStatus, 
          selectedElementsId: [],
          editElementId: undefined,
          overElementId: undefined,
          selectedElementIsEditing: false,
          showDescribedLayerColor: show
      });
  }

    const onShowPicker = (picker: IPickerType, pickerProperties?: IPickerProperties) => {


        setEditorStatus({...editorStatus, currentPicker: picker, pickerProperties: pickerProperties, currentSubPicker:undefined});
    }

    const onShowSubPicker = (subpicker: ISubPickerType, subPickerProperties?: ISubPickerProperties, selectDescribeFieldId?: string[]) => {                        
        let elementsId :string[] = [];
        if (selectDescribeFieldId)
            elementsId = getTaggedVisibleElementsId(selectDescribeFieldId, selectDescribe.taggedFields, data);
        setEditorStatus({
            ...editorStatus,
            editElementId: undefined,
            overElementId: undefined,
            selectedElementIsEditing: false,
            showCropImage: false,
            beforeCroppedImage: {},
            selectedElementsId: elementsId,
            currentSubPicker: subpicker,
            subPickerProperties:subPickerProperties
        });
        onShowSearchImages(false);

    }

    const onShowSearchImages = (show: boolean) => setSearchImages(show);
    
    const onSavingParsedTree = (saving: boolean, showSavingMessage?: boolean, ids?: string[], updatingSelectDescribe?: boolean) => {
       
        let newSaveStatus = {...saveStatus};
        newSaveStatus.savingParsedTree = saving;
        if (updatingSelectDescribe!==undefined) {
            newSaveStatus.updatingSelectDescribeTaggedElements = updatingSelectDescribe;
        }
        else {
            if (!saving) {
                newSaveStatus.updatingSelectDescribeTaggedElements = false;
            }
        }
        newSaveStatus.showSavingStatus = showSavingMessage!==undefined ? showSavingMessage : saveStatus.showSavingStatus;        
               

        if (!saving)
        {
            newSaveStatus.saveVersion = false;
            newSaveStatus.savePending = false;
        }
        
        setSaveStatus({...newSaveStatus});
               
    }
    const addUpdatePreviews = async ( ) => {
        let newPreviews: Preview[] = [];
        
        data[0].children?.forEach((artboard: IElement) => {
            const previewFormat = dsConfig && dsConfig.editorConfig && dsConfig.editorConfig.previewConfig?dsConfig.editorConfig.previewConfig.format:"jpeg";
            const previewName = `${entityInformation.id}/${artboard.id}.${previewFormat}`;
            const url = `https://${storageAccountName}.blob.core.windows.net/${containerName}/${previewName}`;

            newPreviews.push({
                name: artboard.id, 
                url: url,
                size: `${artboard.attributes.width}x${artboard.attributes.height}`
              });
        });
        if (newPreviews.length>0) {
            entityInformation.previews = newPreviews;
            if (entityInformation.entityType==="TEMPLATE") await saveTemplate((entityInformation as ITemplate));
            else  {
                dispatch(actions.designs.updateDesign((entityInformation as IDesign), "", (result: any, error: any) => {}))
            }
        }
    }

    const onSavingPreview = async (data:string[], name:string, inmediate?: boolean) => {        
        dispatch(actions.parsedTrees.updateArtboardPreview(data, entityInformation.id, name, inmediate ));        
    }

    const onExportArtboradMedia = async (data:string[], dealerId:string, collection:string, prefix:string, access_token:string,  name:string, overwrite?:boolean, inmediate?: boolean) => {        
        dispatch(actions.parsedTrees.exportArtboardMedia(data,dealerId,collection,prefix,access_token, entityInformation.id, name,overwrite,inmediate ));        
    }

    const onExporting = (exporting: boolean, exportingProperties?: IExportingProperties) => {              
        setEditorStatus({
            ...editorStatus, 
            exporting: exporting,             
            exportingProperties: exportingProperties, 
            selectedElementsId: [],
            selectedElementIsEditing: false
            })        
    };
    const onExportingPropsChange = (exportingProperties?: IExportingProperties)=> {
        setEditorStatus({
            ...editorStatus, 
            exportingProperties: exportingProperties
        })
    };

    const onExportingCompress = (size?:number, ratio?:number, id?:string) => {
        let expsize = editorStatus.exportingSizes
        if (expsize)
        {
            if (id)
            {
                let idfound = expsize.find(f=> f.id ===id)
                if (idfound)
                {
                    if (size)
                        idfound.size = size;
                    if (ratio)
                        idfound.ratio = ratio;

                }
                else
                {
                    let newid : IExportingSize ={
                        id: id,                    
                        size:size??0,
                        ratio:ratio??0
                    }
                    expsize.push(newid)
                }
            }
            else
            {
                if (expsize.length>0)
                {
                    if (size)
                        expsize[0].size = size
                    if (ratio)
                        expsize[0].ratio = ratio
                }
                else{
                    let newid : IExportingSize ={
                        id: undefined,                    
                        size:size??0,
                        ratio:ratio??0
                    }
                    expsize.push(newid)
                }
            }            
            setEditorStatus({...editorStatus, exportingSizes:expsize})
        }
    };        
    
    const onShowCropImage = (show: boolean, save?:boolean) => {
        let beforeCroppedImage = {}
        if (show && editorStatus.selectedElementsId.length>0) {
            const element = findElementById(data,editorStatus.selectedElementsId[0]);
            if (element) {
                const oldSize : IResizeValues={
                    x: element.attributes.x,
                    y: element.attributes.y,
                    rotation: element.attributes.rotation,
                    width: element.attributes.width,
                    height: element.attributes.height,  
                    image : {
                        x: element.attributes.image.x,
                        y: element.attributes.image.y,
                        width: element.attributes.image.width,
                        height: element.attributes.image.height  
                    }
                }
                beforeCroppedImage = oldSize;
            }
        }

        setEditorStatus({...editorStatus, 
            showCropImage: show, 
            beforeCroppedImage: beforeCroppedImage, 
            currentPicker: undefined,
            currentSubPicker:undefined
        });
    }

    const onCancelCropImage = () => {
        onCommandChange("resize",editorStatus.beforeCroppedImage);
    }
    
    const onSelectorActive = (value: string, ids: string[]) => {
        setSelectorActive(value);
        if (value==="active") {
            setEditorStatus({...editorStatus, selectedElementsId: ids});
        } else {
            
            setEditorStatus({
                ...editorStatus,
                selectedElementsId: ids,
                selectedElementIsEditing: false,
                showCropImage: false,
                beforeCroppedImage: {}
            });
        }
    }
    
    const onIsPickerFocused = (value: boolean) => {
        setEditorStatus({...editorStatus, isPickerFocused: value});
    }
    
    const onZoomChange = (value: number, point?: string) => {                
        if (value>5 && value<=500) {
            setEditorStatus({...editorStatus, zoom: { value: value, point: point ? point :  "center"}});
        }
    }

    const onDraggingNewElement = (value: boolean) => {
        setEditorStatus({...editorStatus, draggingNewElement: value});
    }

    const onDraggingData = (value?: IDraggingData) => {
        setEditorStatus({...editorStatus, draggingData: value});
    }

    const onDraggingChange = (value: boolean) => {
        setEditorStatus({...editorStatus, dragging:value});
    }

    const EditorSelectedElementsIdChange = (id?: string) => {
        let ids = [...editorStatus.selectedElementsId]; 
        const multipleSelection = editorStatus.isShiftPressed && editorStatus.selectedElementsId.length>0;
        if (multipleSelection && ids && id){
            if (ids.includes(id)) {
                const indx = ids.indexOf(id);
                if (indx>-1){
                    
                    ids.splice(indx,1);
                }
            }
            else {
                ids?.push(id);
            }
        }
        else {
            if(id) {
                ids = new Array(id);
            }
            else {
                ids = [];
            }
        }
        setEditorStatus({
            ...editorStatus,
            selectedElementsId: ids,
            selectedElementIsEditing: false,
            showCropImage: false,
            beforeCroppedImage: {}
        });
    }

    const updateTaggetFields = (ids: string[], selectDescribeCategoryId?: string, snackBar?: any) => {
        if (editorStatus.selectedSelectDescribeCategoryId || selectDescribeCategoryId) {
            let tagged = selectDescribe.taggedFields;
            let index = tagged.map((taggedField)=>{ return taggedField.id;}).indexOf(selectDescribeCategoryId??editorStatus.selectedSelectDescribeCategoryId!);
            if (index == -1){
                index = tagged.length;
                tagged.push({id: selectDescribeCategoryId??editorStatus.selectedSelectDescribeCategoryId!, type: getCategoryType(selectDescribeCategoryId??editorStatus.selectedSelectDescribeCategoryId!,selectDescribe.templateFields), taggedElements: []});
            }
            tagged[index].taggedElements = ids;
            setSelectDescribe({
                ...selectDescribe,
                taggedFields: tagged
            });
            updateParsedTreeFieldTags(tagged[index], snackBar);
            if (entityInformation.entityType==="TEMPLATE" && !(entityInformation as ITemplate).described) {
                let template : ITemplate = {...(entityInformation as ITemplate), described: true};
                onEditEntityInformation(template);
            }
        }
    }

    const SelectDescribeSelectedElementsIdChange = (id?: string) => {
        if (editorStatus.selectedSelectDescribeCategoryId!==undefined) {
            const categoryTagged = id!==undefined?getCategoryElementTagged(id, selectDescribe.taggedFields):undefined;
            if (categoryTagged!==undefined && editorStatus.selectedSelectDescribeCategoryId!==categoryTagged)
            {
                onWarningScreenChange(true,"Element Already Tagged","Elements that were tagged to a category cannot be tagged to a different category", "", () => {onWarningScreenChange(false, "", ``, "", undefined, "", "", [])}, "OKAY", "Element Already Tagged", []);
            }
            else
            {
                let ids = editorStatus.selectedElementsId; 
                if (ids && id){        

                    const indx = ids.indexOf(id);
                    if (indx>-1) {
                        ids.splice(indx,1);
                    }
                    else {
                        ids?.push(id);
                    }
                }
                else {
                    if(id) {
                        ids = new Array(id);
                    }
                    else {
                        ids = [];
                    }
                }
                setEditorStatus({
                    ...editorStatus,
                    selectedElementsId: ids
                });
                updateTaggetFields(ids);
            }
        }
        else {
            onWarningScreenChange(true,"Select A Field","Please select a field in the left panel to start tagging elements.", "", () => {onWarningScreenChange(false, "", ``, "", undefined, "", "", [])}, "OKAY", "", []);
        }
    }

    const onGroupOpenStatusChange = (id: string) =>{ 
        let groupsStatus = editorStatus.groupsStatus;
        let index = editorStatus.groupsStatus.map((group) => {return group.groupId}).indexOf(id);
        if (index!==-1) {
            groupsStatus[index].isOpen = !groupsStatus[index].isOpen;
            setEditorStatus({
                ...editorStatus,
                groupsStatus: groupsStatus
            });
        }
    }

    const handleCopyToClipBoard = (dsConfig: IDSConfig, elements: IElement[], setName?: string): IClipBoardElement[] => {
        let copiedElements: IClipBoardElement[] = [];
        if (editorStatus.selectedArtboardIds && editorStatus.selectedArtboardIds.length>0 && (editorStatus.selectedElementsId.length==0))
        {            
            elements.forEach((selectedElement) => {
                copiedElements.push(prepareArtboardForClipBoard(selectedElement, data, dsConfig));
            });
        }
        else if (setName) {
            elements.forEach((selectedElement) => {
                copiedElements.push(prepareSetForClipBoard(selectedElement, setName, data));
            });
        }
        else
        {
            elements.forEach((selectedElement) => {
                if (selectedElement.type === 'Image' || selectedElement.type === 'Text' || selectedElement.type === 'Shape') {
                    copiedElements.push(prepareElementForClipBoard(selectedElement, data));
                }
            });
        }

        setEditorStatus({
            ...editorStatus,
            clipBoard: copiedElements
        });        
        return copiedElements;
    }

    const handleClipBoardForReCopy = (idsPasted: string[], clipBoard: IClipBoardElement[], dsConfig:any) => {
        
        const newClipBoard = prepareClipBoardForReCopy(clipBoard, data,dsConfig);

        if (editorStatus.selectedArtboardIds && editorStatus.selectedArtboardIds.length>0 && (editorStatus.selectedElementsId.length==0))
        {
            setEditorStatus({
                ...editorStatus,
                selectedArtboardIds: idsPasted,
                clipBoard: newClipBoard,
                refreshStage:true
    
            });         
            
            setSaveStatus({
                ...saveStatus,
                savingParsedTree: true,
                showSavingStatus: true
            })
        }
        else
        {
            setEditorStatus({
                ...editorStatus,
                selectedElementsId: idsPasted,
                clipBoard: newClipBoard,
    
            });
            setSaveStatus({
                ...saveStatus,
                savingParsedTree: true,
                showSavingStatus: true
            })
        }
        
    }

    const onSelectedElementsIdChange = (id?: string) =>{ 
        if (!editorStatus.showSelectDescribe) {            
                EditorSelectedElementsIdChange(id);
        }
        else {
            SelectDescribeSelectedElementsIdChange(id);
        }
    }

    const onMultiEditingFocus = async (selectDescribeFieldId: string[]) => {
        let elementsId = getTaggedVisibleElementsId(selectDescribeFieldId, selectDescribe.taggedFields, data)
        setEditorStatus({
            ...editorStatus,
            editElementId: undefined,
            overElementId: undefined,
            selectedElementIsEditing: false,
            showCropImage: false,
            beforeCroppedImage: {},
            selectedElementsId: elementsId,
            currentSubPicker: undefined,
            subPickerProperties:undefined
        });
    }

    const onWarningScreenChange = (open: boolean, title:string, subtitle:string, actionTitle:string, actionFunction:any, closeActionTitle:string, errorNote:string, errorArguments: any, secondaryFunction?: any) =>{ 
        setWarningStatus({
            showWarningScreen: open, 
            warningOptions: {
                title: title,
                subtitle: subtitle,
                actionTitle: actionTitle,
                actionFunction: actionFunction,
                closeActionTitle: closeActionTitle,
                errorNote: errorNote,
                errorArguments: errorArguments,
                secondaryFunction: secondaryFunction
            }
        });
    }

    const onSelectedSelectDescribeCategoryIdChange = (id?: string) =>{ 
        setEditorStatus({
            ...editorStatus,
            selectedSelectDescribeCategoryId: id,
            editElementId: undefined,
            overElementId: undefined,
            selectedElementIsEditing: false,
            selectedElementsId: id!==undefined?getTaggedElementsId([id], selectDescribe.taggedFields):[],
        });
    }

    const onSelectDescribeCategoryClearAll = (id: string) =>{ 
        setEditorStatus({
            ...editorStatus,
            selectedSelectDescribeCategoryId: id,
            editElementId: undefined,
            overElementId: undefined,
            selectedElementIsEditing: false,
            selectedElementsId: [],
        });
        updateTaggetFields([], id);
    }

    const onSelectDescribeCategoryAdd = (idCategory: string, categoryName: string) =>{ 
        let tagged = selectDescribe.taggedFields;
        let index = tagged.map((taggedField)=>{ return taggedField.id;}).indexOf(idCategory??editorStatus.selectedSelectDescribeCategoryId!);
        if (index == -1){
            index = tagged.length;
            tagged.push({id: idCategory??editorStatus.selectedSelectDescribeCategoryId!, type: getCategoryType(idCategory??editorStatus.selectedSelectDescribeCategoryId!,selectDescribe.templateFields), taggedElements: []});
        }
        let ids = [...editorStatus.selectedElementsId, ...tagged[index].taggedElements]

        updateTaggetFields(ids, idCategory, {count: ids.length, categoryName: categoryName});
        setEditorStatus({
            ...editorStatus,
            selectedSelectDescribeCategoryId: undefined,
            editElementId: undefined,
            overElementId: undefined,
            selectedElementIsEditing: false,
            selectedElementsId: [],
        });
    }

    const onSelectedArtboardChange = (id?: string, selector?: string) => {
        const idIndex = editorStatus.selectedArtboardIds?.findIndex((artboardId: string) => (artboardId === id));
        if (id === undefined) {
            let ids = editorStatus.selectedElementsId;
            if(!editorStatus.showSelectDescribe ) {
                ids=[];
            }
            setEditorStatus(
                {
                    ...editorStatus, 
                    selectedArtboardIds: [], 
                    selectedElementsId: ids, 
                    selectedElementIsEditing: false
                }
            );
        } else if (idIndex !== undefined && idIndex >= 0) {
            setEditorStatus({
                ...editorStatus,
                selectedElementsId: (selector === "off" && !editorStatus.showSelectDescribe) ?  [] : editorStatus.selectedElementsId,
                selectedArtboardIds: editorStatus.selectedArtboardIds && editorStatus.isShiftPressed ? [
                ...editorStatus.selectedArtboardIds.slice(0, idIndex),
                ...editorStatus.selectedArtboardIds.slice(idIndex + 1)
                ] : [id]
            })
        } else {
            setEditorStatus({
                ...editorStatus,
                selectedElementsId: (selector === "off" && !editorStatus.showSelectDescribe) ? [] : editorStatus.selectedElementsId,
                selectedArtboardIds: editorStatus.selectedArtboardIds && editorStatus.isShiftPressed ? [...editorStatus.selectedArtboardIds, id] : [id],
            })
        }
    }

    useEffect(() => {
        if (!editorStatus.selectedElementIsEditing) {
            setEditorStatus({
                ...editorStatus,
                textSelectionInformation: undefined
            });
        }
    }, [editorStatus.selectedElementIsEditing])

    const onSelectedElementIsEditing = (id?: string, isEditing?: boolean, offsetX?:number, offsetY?:number, height?:number) =>{      
        setEditorStatus({
            ...editorStatus,
            editElementId: id,
            selectedElementIsEditing: isEditing,
            selectedOffsetX: offsetX,
            selectedOffsetY: offsetY,
            selectedElementHeight: height,
        });
    }

    const onSelectedText = (textSelectionInformation: ITextSelectionInformation) =>{      
        setEditorStatus({
            ...editorStatus,
            textSelectionInformation: textSelectionInformation
        });
    }

    const onOverElementIdChange = (id?: string, isOver?: boolean) =>{      
        if(isOver) {
            if (!editorStatus.showCropImage && !addInsStatus.addInRotationStatus.visible) {
                setEditorStatus({
                    ...editorStatus,
                    overElementId: id
                });
            }
        }
        else {
            if (id && editorStatus.overElementId === id) {
                setEditorStatus({
                    ...editorStatus,
                    overElementId: undefined
                });
            }
        }
    }

    const onScrolling = (scrollX?:number, scrollY?:number) =>{             
        setEditorStatus({
            ...editorStatus,
            scrollX: scrollX,
            scrollY: scrollY
        });
    }

    const onCommandChange = (command: string, value?: any, ids?: string[], values?: any[], notAutoSave?: boolean, multiEditingMode?: boolean, showSavingMessage?: boolean, commandOrigin?: string) => {
        if (command === "removeElement" && !(!editorStatus.selectedElementIsEditing &&
            (editorStatus.selectedElementsId.length > 0 || (editorStatus.selectedArtboardIds && editorStatus.selectedArtboardIds.length > 0)))
        ) return;
        
        //let refreshStage= false;
        let undoCommands: IUndoRedoCommand[] = [];
        showSavingMessage = (showSavingMessage===undefined ? true : showSavingMessage);                
        // 1.- Update editor status
        const commandOptionIndex = editorStatus.commandOptions.findIndex(co => co.name === command);
        if (commandOptionIndex >= 0) {
            setEditorStatus({...editorStatus, commandOptions: 
                [...editorStatus.commandOptions.slice(0,commandOptionIndex),
                { name: command, value: value },
                ...editorStatus.commandOptions.slice(commandOptionIndex+1)]
            });     
        } else {
            setEditorStatus({...editorStatus, commandOptions: 
                [...editorStatus.commandOptions, { name: command, value: value }]
            });
        }
    
        // 2.- Update selected elements
        if (editorStatus.selectedElementsId.length > 0 || (ids && ids.length > 0) || (editorStatus.selectedArtboardIds && editorStatus.selectedArtboardIds.length > 0)) {
            let undoData: ICommandInformation = {command: command, data: cloneDeep(data), selectDescribe: cloneDeep(selectDescribe), artboardsZIndexChain: cloneDeep(artboardsZIndexChain) };

            if (!notAutoSave && temporaryUndoInfo!==undefined) {
                let commandUndoInitial = temporaryUndoInfo;
                undoData = commandUndoInitial;
            }

            let notUpdateEditorStatus = false;
            let elementsId: string[] = [];
            if (ids?.length)
                elementsId = ids;
            else if (editorStatus.selectedElementsId.length > 0) 
                elementsId = cloneDeep(editorStatus.selectedElementsId);         
            else if (editorStatus.selectedArtboardIds && (
                    (command === "removeElement" && editorStatus.selectedArtboardIds.length === 1 && data[0]?.children && data[0].children.length > 1) ||
                    (command !== "removeElement" && editorStatus.selectedArtboardIds.length > 0)))
                elementsId = cloneDeep(editorStatus.selectedArtboardIds);
                        
            if (command=="text" && !multiEditingMode) {
                elementsId = [editorStatus.editElementId!];                
            }

            let elements: (IElement|undefined)[] = [];
            if(dsConfig && editorStatus.currentPicker === "MultiEditing" && command!=="hideUnhide" && command!=="lockUnlockElement") {
                elementsId.map((elementId) => {
                    let element = findElementById( data, elementId );
                    if (element && element.attributes.locked!==true) elements.push(element);
                })
            } else {
                elements = elementsId.map((elementId) => {
                    return findElementById( data, elementId );
                })
            }

            let notSelectedIds: string[] = [];
            if (command==="removeElement"){
                values = [...elements];
                elements = values.map((value) => { 
                    if (value !== undefined) {
                        notSelectedIds.push((value as IElement).id);
                        return getParentElement((value as IElement).id, data);
                    }
                });
            }
            
            
            let commandMove : IElement | undefined =  undefined;
            if (command==="moveElement" && ids){
                commandMove = cloneDeep(elements[0]);
                let elementInfo  = elements[0] ? resolver(elements[0], "resize", value.elementInfo, data) : undefined;
                elements = [...elements].map((elmt) => { 
                    if (elmt !== undefined) return getParentElement(ids[0], data);
                });
                elements.push(findElementById( data, value.newParentId));
                value = elementInfo;
            }
            
            let commandDrag = command==="multiDragEnd";
            if (command==="multiDragEnd"){
                let newElements: (IElement|undefined)[] = [];
                let newValues: any[] = [];
                elements.forEach((element: any, index: number) => {                     
                    if (values && values[index]?.command==="removeElement" && element) {
                        newValues.push({...element, command : "removeElement"});
                        newElements.push(getParentElement((element as IElement).id, data));
                        notSelectedIds.push((element as IElement).id);
                    } else if (values && values[index]?.command==="moveElement" && element) {
                        newValues.push({...cloneDeep(element), command : "removeElement"});
                        newElements.push(getParentElement(element.id, data));

                        let elementInfo  = resolver(cloneDeep(element), "resize", values[index].elementInfo, data);
                        newValues.push({...elementInfo, command : "addElement"});
                        newElements.push(findElementById( data, values[index].newParentId));
                    }
                    else if (element) {
                        newElements.push(element);
                        if (values) newValues.push({...values[index], command : values[index].command==="resizeArtboard"?values[index].command:"resize"});
                    }
                });
                elements = newElements;
                values = newValues;
            }
            
            if (command=="copypaste") {      
                
                
                notUpdateEditorStatus = true;
                let clipBoard = editorStatus.clipBoard;
                if ((value as ICopyPasteCommandValue).copy) {
                    clipBoard = handleCopyToClipBoard(dsConfig, elements.filter((e): e is IElement => Boolean(e)), value.setName);                                        
                }

                

                if ((value as ICopyPasteCommandValue).paste) {
                    elements = clipBoard.map((clipBoardItem) => {
                        return findElementById(data, clipBoardItem.parentId);
                    });
                    values = clipBoard;
                    handleClipBoardForReCopy(clipBoard.map((clipBoardElement)=>{return clipBoardElement.element.id}), clipBoard,dsConfig);
                    //refreshStage=true;
                }
                else {
                    elements = [];
                }
            }

            let newSelectDescribe: ISelectDescribeData = cloneDeep(selectDescribe);
            let selectDescribeChange: boolean = false;

            let updatedData = cloneDeep(data);
            let updatedArtboardsZIndexChain = cloneDeep(artboardsZIndexChain);

            for (let i=0;i<elements.length;i++) {
                const index=i;
                const element = elements[i];
                if (element) {
                    if (commandMove && index===0) command="removeElement";
                    else if (commandMove && index===1) command="addElement";
                    

                    if (values && commandDrag && values[index]?.command) command = values[index]?.command;
                    //undoredo per command
                    //let undoRedoCommand: IUndoRedoCommand = {undo: getUndoRedoCommand(element, command, "UNDO"), redo: undefined};  
                    //if (!notAutoSave && temporaryUndoInfo.length!==0) {
                        //let commandUndoRedo = temporaryUndoInfo.find(command => command.undo.idElement===element.id);
                        //if (commandUndoRedo) undoRedoCommand.undo = commandUndoRedo.undo;
                    //}
                    let endValue = values && values[index] !== undefined ? values[index] : value;
                    if (!notAutoSave) {
                        let valueForUndo: any = undefined;
                        //let commandForUndo = command;
                        //let selectDescribeForUndo = undefined;
                        if (command === "copypaste") {
                            //commandForUndo = "addElement";

                                if ((endValue as IClipBoardElement).element.type == "Artboard" || value.setName)
                                {
                                    const elementSelectDescribe = getSelectDescribeCopyPasteArtboardChild(
                                        (endValue as IClipBoardElement).element.children!,
                                        (endValue as IClipBoardElement).originalElement.children ?? [],
                                        newSelectDescribe,
                                        dsConfig.selectDescribeConfig.categories
                                    );
                                    if (elementSelectDescribe) {
                                        newSelectDescribe = elementSelectDescribe;
                                        //selectDescribeForUndo = cloneDeep(selectDescribe);
                                        selectDescribeChange = true;
                                    }
                                }
                                else
                                {
                                    const elementSelectDescribe = getSelectDescribeCopyPaste((endValue as IClipBoardElement).element.id,(endValue as IClipBoardElement).originalElement, newSelectDescribe, dsConfig.selectDescribeConfig.categories);
                                    if (elementSelectDescribe) {
                                        newSelectDescribe = elementSelectDescribe;
                                        //selectDescribeForUndo = cloneDeep(selectDescribe);
                                        selectDescribeChange = true;
                                    }
                                }
                        }

                        if (command === "removeElement" || command === "addElement") {
                            valueForUndo = endValue;
                            if (command === "removeElement") {
                                let endValues = [];
                                if (["Image", "Text", "Shape"].includes((endValue as IElement).type)) {
                                    endValues = [endValue];
                                }
                                else {
                                    //when removing artboards or groups
                                    endValues = getDeepestElements(endValue);
                                }
                                endValues.map(value => {
                                    const elementSelectDescribe = revomeFromSelectAndDescribe((value as IElement).id,newSelectDescribe);
                                    if (elementSelectDescribe) {
                                        newSelectDescribe = elementSelectDescribe;
                                        selectDescribeChange = true;
                                    }
                                });
                                //if (selectDescribeChange) selectDescribeForUndo = cloneDeep(selectDescribe);
                            }
                        }
                        if (command === "copypaste") {
                            valueForUndo = endValue.element;
                        }

                        //if (commandMove && command==="removeElement") valueForUndo = {...commandMove};

                        /*
                        if (["copypaste", "removeElement", "addElement", "changePositionsChain"].includes(command)) {
                            //undoredo per command
                            //undoRedoCommand = {undo: getUndoRedoCommand(element, commandForUndo, "UNDO", valueForUndo, selectDescribeForUndo, updatedArtboardsZIndexChain), redo: undefined};
                        }
                        */
                    }
                    let updatedElementResolver = element;  
                    if (command !== "changePositionsChain") {                        
                        updatedElementResolver = resolver(element, command, endValue, value, editorStatus.textSelectionInformation, notAutoSave, commandOrigin);  
                        updatedData = updateElement(updatedData, updatedElementResolver);
                        //uncomment this to update just the elements changed
                        //updatedElements = mergeElements(updatedElements, updatedElementsResolver);
                        let IdsMapping = command === "copypaste" ? getMappingFromClipboard(endValue):[];
                        //TODO: Use editor/findArtboardIndex - 2nd parm is an element Id from Original artboard
                        let originalArtboardIndex = command === "copypaste" ? getOriginalArtboardIndexFromClipboard(endValue):undefined;
                        //updatedArtboardsZIndexChain = updateArtboardsZIndexChain(updatedData[0], updatedArtboardsZIndexChain,editorStatus.clipBoard);
                        updatedArtboardsZIndexChain = updateArtboardsZIndexChain(updatedData[0], updatedArtboardsZIndexChain,IdsMapping,originalArtboardIndex);
                    }
                    else {
                        updatedArtboardsZIndexChain = value;
                    }
                    /*
                    let valueForRedo: any = undefined;
                    if (command === "removeElement" || command === "addElement" || command === "copypaste") {
                        //undoredo per command
                        //if (commandMove && command==="removeElement") valueForRedo = cloneDeep(undoRedoCommand.undo.value);
                        //else valueForRedo = {...endValue};
                    }
                    if (["copypaste", "removeElement", "addElement", "changePositionsChain"].includes(command)) {
                        //undoredo per command
                        //undoCommands.push({...undoRedoCommand!, redo:getUndoRedoCommand(updatedElementResolver, command, "REDO", valueForRedo, newSelectDescribe, updatedArtboardsZIndexChain)});
                    }
                    else {
                        //if (command === "srcImage") valueForRedo = {...endValue, srcImage: endValue.newSrcImage, brandId: endValue.brandId, brandImage: endValue.brandImage, brandImageType: endValue.brandImageType};
                        if (command === "srcImage") valueForRedo = {...endValue, srcImage: endValue.newSrcImage, brandId: endValue.brandId, brandImageType: endValue.brandImageType};
                        //undoredo per command
                        //undoCommands.push({...undoRedoCommand!, redo:getUndoRedoCommand(updatedElementResolver, command, "REDO", valueForRedo, newSelectDescribe)});
                    }
                    */
                    
                    //undoredo per command
                    //if (command === "removeElement") elementsId.splice(elementsId.indexOf(valueForRedo.id), 1);
                }
            };

            const redoData: ICommandInformation = {command: command, data: cloneDeep(updatedData), selectDescribe: selectDescribeChange?cloneDeep(newSelectDescribe):cloneDeep(selectDescribe), artboardsZIndexChain: cloneDeep(updatedArtboardsZIndexChain) };
            undoCommands.push({undo: undoData, redo: redoData});

            setData(updatedData);
            setArtboardsZIndexChain(updatedArtboardsZIndexChain);

            if (selectDescribeChange) {
                setSelectDescribe(newSelectDescribe);
            }
            if (!notAutoSave) {
                let elementsId: string[] = [];                
                if (command === "addElement" && values) elementsId = values.map(value => {return value.id});                
                updateParsedTreeElements(updatedData, newSelectDescribe, showSavingMessage, notUpdateEditorStatus, updatedArtboardsZIndexChain, elementsId, saveStatus.saveVersion);
                //uncomment this to update just the elements changed
                //updateParsedTreeElements(updatedElements, newSelectDescribe, showSavingMessage, notUpdateEditorStatus, childrensUpdate);
            }

            //Update editor status in case of delete one o many elements.
            if ((commandDrag || command === "removeElement") && command !== "resizeArtboard") {
                let filterIds : string[] = elementsId.filter((id: string) =>! notSelectedIds.includes(id));
                setEditorStatus({
                    ...editorStatus,
                    selectedElementsId: filterIds,
                    selectedArtboardIds: editorStatus.selectedArtboardIds && editorStatus.selectedArtboardIds[0] === elementsId[0] ? [] : editorStatus.selectedArtboardIds,
                    editElementId: undefined,
                    selectedElementIsEditing: false,
                });
            }

            /*if (command==="copypaste" && refreshStage)
            {                
                setEditorStatus({
                    ...editorStatus,
                    refreshStage:true
                });
            }*/

        }        
        

        // 3.- Undo / redo
        if (notAutoSave) {
            if (temporaryUndoInfo===undefined) setTemporaryUndoInfo(undoCommands[0].undo)
        }
        else {
            if (showSavingMessage) setDataUndo([...dataUndo, undoCommands]);
            setDataRedo([]);
            setTemporaryUndoInfo(undefined);
        }
    }; 

    const getOriginalArtboardIndexFromClipboard = (clipBoard: any) => {
        if(!data || data.length===0 || !clipBoard) return 0;
        let artBoards = data[0].children ? data[0].children:[] ;
        if(artBoards.length>0) {
            return artBoards.findIndex((element: any) => element.id === clipBoard.originalElement.id);
        }
    }
    const getMappingFromClipboard = (clipBoard: any) => {
        //IClipBoardElement
        let mapping: any = [];
        if (clipBoard) {
            if (clipBoard.element.type === "Artboard" && clipBoard.originalElement.type === "Artboard") {
                let originalArtboard = clipBoard.originalElement;
                let newArtboard = clipBoard.element;
                if (originalArtboard.children && originalArtboard.children.length>0 && newArtboard.children && newArtboard.children.length>0 && originalArtboard.children.length===newArtboard.children.length) {
                    let originalZIndexChain = getArtboardZIndexChain(originalArtboard);
                    let newZIndexChain = getArtboardZIndexChain(newArtboard);
                    for (let i=0; i<originalZIndexChain.length; i++) {
                        mapping.push({originalId: originalZIndexChain[i], id: newZIndexChain[i]});
                    }
                }    
            }
        }
        return mapping;
    }

    const onColorAdded = async (color: string) => {
        let colors = colorPalette;
        if(!colors.includes(color)){
            let modifyLastColor = false;
            if (colors.length>0 && !otherElementHasColor(editorStatus.selectedElementsId, colors[colors.length-1], data) ) {
                modifyLastColor = true;
            }
            if (modifyLastColor) {
                colors[colors.length-1] = color;
            }
            else {
                colors.push(color);
            }
            await updateParsedTreeField(colors);
            setColorPalette(colors);
        }
    }; 

    const uuid = require('react-uuid');

    const onTemplateCategoryAdded = (parentCategoryId: string, parentCategoryName: string) => {
        let name = parentCategoryName + FindNextNumber(parentCategoryId, parentCategoryName, selectDescribe).toString();
        let newTemplateCategories = selectDescribe.templateFields??[];
        newTemplateCategories.push({id: uuid(), parentId: parentCategoryId, name: parentCategoryName + FindNextNumber(parentCategoryId, parentCategoryName, selectDescribe).toString()});
        setSelectDescribe({
            ...selectDescribe,
            templateFields: newTemplateCategories
        });
        updateParsedTreeTemplateFields(newTemplateCategories);
    }; 
    
    const onTemplateCategoryRemoved = (templateCategoryId: string) => {
        let newTemplateCategories = selectDescribe.templateFields;
        let index = newTemplateCategories.findIndex((category)=> category.id === templateCategoryId);
        newTemplateCategories.splice(index,1);

        let tagged = [];
        for(let i=0;i<selectDescribe.taggedFields.length;i++){
            if(selectDescribe.taggedFields[i].id!==templateCategoryId){
                tagged.push(selectDescribe.taggedFields[i]);
            }
        }
        setSelectDescribe({
            ...selectDescribe,
            taggedFields: tagged,
            templateFields: newTemplateCategories
        });

        if(templateCategoryId===editorStatus.selectedSelectDescribeCategoryId){
            onSelectedSelectDescribeCategoryIdChange(undefined);
        }
        updateParsedTreeTemplateFields(newTemplateCategories);
    }; 

    const onRotation = (rotation?: number, x?: number, y?: number, offsetX?: number, offsetY?: number) => {
        if(offsetX && offsetY){
            setEditorStatus({
                ...editorStatus,
                selectedOffsetX: offsetX,
                selectedOffsetY: offsetY
            });
        }
        if(rotation) {
            setAddInsStatus({...addInsStatus, addInRotationStatus: {visible: true, rotation: rotation, x: x, y: y}});
        }
        else {
            setAddInsStatus({...addInsStatus, addInRotationStatus: {visible: false, rotation: rotation, x: x, y: y}});
        }
    }; 

    const onHandleShift = (value: boolean) => {
        setEditorStatus({...editorStatus, isShiftPressed: value})
    };

    const updateParsedTreeFieldTags = (fieldTags: ITaggedField, snackBar?: any) => {
        const userData = {
            email: authContext?.userData.profile.email ? authContext?.userData.profile.email : "defaultuser@tangocode.com",
            name: authContext?.userData.profile.name ? authContext?.userData.profile.name : "Default User"
        };
        onSavingParsedTree(true, undefined, undefined, true);
        dispatch(actions.parsedTrees.setUpdateParsedTreeFieldTags(undefined));
        updateParsedTreeFieldTagsInfo({ id: entityInformation.parsedTree, fieldTags: fieldTags, updatedBy: userData, snackBar: snackBar});
    }

    const updateParsedTreeTemplateFields = (templateFields: ITemplateFields[]) => {
        const userData = {
            email: authContext?.userData.profile.email ? authContext?.userData.profile.email : "defaultuser@tangocode.com",
            name: authContext?.userData.profile.name ? authContext?.userData.profile.name : "Default User"
        };
        dispatch(actions.parsedTrees.setUpdateParsedTreeTemplateFields(undefined));
        updateParsedTreeTemplateFieldsInfo({ id: entityInformation.parsedTree, templateFields: templateFields, updatedBy: userData});
    }

    const updateParsedTreeField = async (colors: string[]) => {
        const userData = {
            email: authContext?.userData.profile.email ? authContext?.userData.profile.email : "defaultuser@tangocode.com",
            name: authContext?.userData.profile.name ? authContext?.userData.profile.name : "Default User"
        };
        onSavingParsedTree(true);
        await dispatch(actions.parsedTrees.setUpdateParsedTreeField(undefined));
        await updateParsedTreeFieldInfo({ id: entityInformation.parsedTree, field: "colorPalette", value: colors, updatedBy: userData});
    }

    const updateParsedTreeElements = async (elements: IElement[], selectDescribe?: ISelectDescribeData, showSavingMessage?: boolean, notUpdateEditorStatus?: boolean, updatedArtboardsZIndexChain?: IArtboardZIndexChain[], elementsId?: string[], saveVersion?:boolean) => {
        
        let newSaveObj:(ISave) = {
            save:true,
            elements: elements,
            selectDescribe: selectDescribe,
            showSavingMessage: showSavingMessage,
            notUpdateEditorStatus: notUpdateEditorStatus,
            updatedArtboardsZIndexChain: updatedArtboardsZIndexChain,
            elementsId: elementsId,
            saveVersion: saveVersion
        }
        
        //if (saveObj)
        //    setSaveObjPending(newSaveObj)
        //else
            setSaveObj(newSaveObj);
    }

  
    const onEditEntityInformation = async (entityInfo: IEntityInformation) => {
      if (entityInfo.entityType === "TEMPLATE") {
        try {
          const result = await saveTemplate((entityInfo as ITemplate));
          return result;
        } catch(e) {
          console.error(e);
          return e;
        }
      } else if (entityInfo.entityType === "DESIGN") {
      }
    }

    const onUpdateEntityInformation = (entityInfo: IEntityInformation) => setEntityInformation(entityInfo);

    const onEditUserFiles = async (newUserFiles: IUserFiles) => {
      try {
        let result: any = {};
        newUserFiles.files = newUserFiles.files.map(file => {return {...file, src: undefined}});
        if (userFiles) result = await saveUserFiles(newUserFiles)
        else result = await sendUserFiles(newUserFiles);
        if (!userFiles) setUserFiles(newUserFiles);
        return result;
      } catch(e) {
        console.error(e);
        return e;
      }
    }

    const onEditUserFilesClose = async (newUserFiles: IUserFiles ) => {
        try {
          let result: any = {};
          newUserFiles.files = newUserFiles.files.map(file => {return {...file, src: undefined}});
          if (userFiles) result = await saveUserFiles(newUserFiles)
          else result = await sendUserFiles(newUserFiles);
          if (!userFiles) setUserFiles(newUserFiles);          
          onShowSearchImages(false);
          return result;
        } catch(e) {
          console.error(e);
          return e;
        }
      }


    const dispatch = useDispatch();
    const updateParsedTreeElementsInfo = (updateElementsInfo: UpdateElementsInfo, saveVersion?:boolean) => {
        dispatch(actions.templates.setCounter({} as any));
        return new Promise((resolve, reject) => {
            dispatch(actions.parsedTrees.updateParsedTreeElements(updateElementsInfo,saveVersion,(result, error) => {
                if (error) reject(error)
                else resolve(result);
            }))
        });
    }

    const updateParsedTreeFieldTagsInfo = ( updateFieldTagsInfo: IUpdateFieldTagsInfo) => {
        return new Promise((resolve, reject) => {
            dispatch(actions.parsedTrees.updateParsedTreeFieldTags(updateFieldTagsInfo,(result, error) => {
                if (error) reject(error)
                else resolve(result);
            }))
        });
    }

    const updateParsedTreeFieldsTagsInfo = ( updateFieldsTagsInfo: IUpdateFieldsTagsInfo) => {
        return new Promise((resolve, reject) => {
            dispatch(actions.parsedTrees.updateParsedTreeFieldsTags(updateFieldsTagsInfo,(result, error) => {
                if (error) reject(error)
                else resolve(result);
            }))
        });
    }

    const updateParsedTreeTemplateFieldsInfo = ( updateTemplateFieldsInfo: IUpdateTemplateFieldsInfo) => {
        return new Promise((resolve, reject) => {
            dispatch(actions.parsedTrees.updateParsedTreeTemplateFields(updateTemplateFieldsInfo,(result, error) => {
                if (error) reject(error)
                else resolve(result);
            }))
        });
    }

    const updateParsedTreeFieldInfo = ( updateFieldInfo: IUpdateFieldInfo) => {
        return new Promise((resolve, reject) => {
            dispatch(actions.parsedTrees.updateParsedTreeField(updateFieldInfo,(result, error) => {
                if (error) reject(error)
                else resolve(result);
            }))
        });
    }

    const saveTemplate = ( template: ITemplate ) => {
        return new Promise((resolve, reject) => {
            dispatch(actions.templates.updateTemplate(template, (result: any, error: any) => {
                if (error) reject(error)
                else resolve(result);
            }))
        })
    }

    const sendUserFiles = (newUserFiles: IUserFiles) => {
      return new Promise((resolve, reject) => {
          dispatch(actions.userFiles.addUserFiles(newUserFiles, (result: any, error: any) => {
              if (error) {
                reject(error);
              } else {
                resolve(result);
              }
          }))
      })
    }

    const saveUserFiles = (newUserFiles: IUserFiles) => {
      return new Promise((resolve, reject) => {
          dispatch(actions.userFiles.updateUserFiles(newUserFiles, (result: any, error: any) => {
              if (error) {
                reject(error);
              } else {
                resolve(result);
              }
          }))
      })
    }


    const mergeElements = (elements: IElement[], newElements: IElement[]): IElement[] => {
        for (let i=0;i<newElements.length;i++) {
            let idx = elements.map((element)=>{ return element.id}).indexOf(newElements[i].id);
            if (idx === -1) {
                elements.push(newElements[i]);
            }
            else {
                elements[idx] = newElements[i];
            }
        }
        return elements;
    }
    const onUndoRedo = ( command: string) => {
        let updateCommands : IUndoRedoCommand[] = [];
        let selectedElementsId = [...editorStatus.selectedElementsId];

        editorStatus.showCropImage = false;
        editorStatus.beforeCroppedImage = {};

        if (command==="undo" && dataUndo.length>0) {
            updateCommands = dataUndo[dataUndo.length-1];
            setDataUndo(dataUndo.slice(0, -1));
            setDataRedo([...dataRedo , updateCommands ]);
        } else if (command==="redo" && dataRedo.length>0) {
            updateCommands = dataRedo[dataRedo.length-1];
            setDataUndo([...dataUndo , updateCommands ]);
            setDataRedo(dataRedo.slice(0, -1));
        }

        let selectDescribeUndoRedo: ISelectDescribeData|undefined;
        let updatedData = cloneDeep(data);
        let updatedArtboardsZIndexChain = cloneDeep(artboardsZIndexChain);
        
        for(let i=updateCommands.length-1;i>=0;i--) {
            const undoRedoCommad: IUndoRedoCommand = updateCommands[i];
            let commandInformation = command==="undo" ? undoRedoCommad.undo : undoRedoCommad.redo; 
            if (commandInformation) {
                //undoredo per command
                /*let  selectedElement: any = findElementById( data, commandInformation.idElement);
                if (selectedElement) { 
                    const updatedElementResolver = resolver(selectedElement, commandInformation.command, commandInformation.value, data);
                    if (commandInformation.artboardsZIndexChain)
                        updatedArtboardsZIndexChain = cloneDeep(commandInformation.artboardsZIndexChain);
                    updatedData = updateElement(updatedData, updatedElementResolver);  
                    //uncomment this to update just elements changed. comment to update all elements
                    //updatedElements = mergeElements(updatedElements, updatedElementsResolver);
                    if (commandInformation.command === "removeElement") selectedElementsId.splice(selectedElementsId.indexOf(commandInformation.value.id), 1);
                }
                if (command==="undo") {
                    if (commandInformation.selectDescribe && selectDescribeUndoRedo === undefined) {
                        selectDescribeUndoRedo = commandInformation.selectDescribe;
                    }
                }
                else {
                    if (commandInformation.selectDescribe) {
                        selectDescribeUndoRedo = commandInformation.selectDescribe;
                    }
                }*/
                updatedData = commandInformation.data;
                updatedArtboardsZIndexChain = commandInformation.artboardsZIndexChain??[]; 
                selectDescribeUndoRedo = commandInformation.selectDescribe; 
            }
        };

        setData(updatedData);
        setArtboardsZIndexChain(updatedArtboardsZIndexChain); 
        if (selectDescribeUndoRedo) {
            setSelectDescribe(selectDescribeUndoRedo);
        }
        //uncomment to update just the elements changed. comment to update all elements.
        //if (updatedElements.length>0) updateParsedTreeElements(updatedElements,selectDescribeUndoRedo,undefined,undefined,childrensUpdate);
        updateParsedTreeElements(updatedData, selectDescribeUndoRedo, true, false, updatedArtboardsZIndexChain, undefined);

        // Update editor status after undo/redo
        setEditorStatus({
            ...editorStatus,
            //undoredo per command
            //selectedElementsId: selectedElementsId,
            selectedElementsId: [],
            selectorActive:  "off"
        });
    }

    const onSelectVersion = (change: IParsedTreeChange) => {       
        
        setEditorStatus({
            ...editorStatus,
            currentVersion: !editorStatus.currentVersion?data:editorStatus.currentVersion,
            selectedVersion: change
        });
        setData(change.data);
    }

    const onSelectCurrentVersion = () =>
    {
        if (editorStatus.currentVersion)        
            setData(editorStatus.currentVersion);
        
        setEditorStatus({
            ...editorStatus,
            currentVersion: undefined,
            selectedVersion: undefined
        });
        
    } 


    const onSelectEditMode = (edit: boolean) => {        
        
        if (edit && editorStatus.currentVersion)
            setData(editorStatus.currentVersion);

        setEditorStatus({
            ...editorStatus,                       
            showDescribedLayerColor: false,
            selectedArtboardIds: [], 
            selectedElementsId: [],
            editElementId: undefined,
            overElementId: undefined,
            selectedElementIsEditing: false,
            selectedSelectDescribeCategoryId: undefined,
            editMode: edit,
            currentVersion: edit?undefined:editorStatus.currentVersion,
            selectedVersion: edit? undefined:editorStatus.selectedVersion,
            currentPicker: edit?undefined:editorStatus.currentPicker
            
        });


    }


    const onRestoreVersion = () => {        
                
        setEditorStatus({
            ...editorStatus,                       
            showDescribedLayerColor: false,
            selectedArtboardIds: [], 
            selectedElementsId: [],
            editElementId: undefined,
            overElementId: undefined,
            selectedElementIsEditing: false,
            selectedSelectDescribeCategoryId: undefined,
            editMode: true,
            currentVersion: undefined,
            selectedVersion: undefined,
            currentPicker: undefined  
        });

        setSaveStatus({
            ...saveStatus,
            savingParsedTree: true,            
        })

    }

    const onSharing = (sharing: boolean) => {              
        setEditorStatus({
            ...editorStatus, 
            sharing:sharing
            })
    };

    const onRefreshStage = (refresh: boolean) => {              
        setEditorStatus({
            ...editorStatus, 
            refreshStage:refresh,
            groupsStatus: AddInitGroupsStatus(data)
            })
    };

   

    const onSetsChange = (set: string) => {              
        setEditorStatus({
            ...editorStatus, 
            setsSelected: set
        })
    };

    const onShowGridOverlay = (show: boolean) => {

        let gridOverlay = editorStatus.gridOverlay;
        if (gridOverlay)
            gridOverlay.show = show;        

        setEditorStatus({
            ...editorStatus, 
            gridOverlay: gridOverlay
        });
    }

    const onChangeGridOverlaySize = (size: number) => {

        let gridOverlay = editorStatus.gridOverlay;
        if (gridOverlay)
            gridOverlay.size = size;        

        setEditorStatus({
            ...editorStatus, 
            gridOverlay: gridOverlay
        });
    }

    const onSavePending = (savePending: boolean) => {                     
        setSaveStatus({
            ...saveStatus, 
            savePending:savePending
            })
    };

    const onDeleteUserFiles = async (files: string[] | null) => {
        try {
          if (!files || files.length === 0) return;
      
          dispatch(actions.userFiles.bulkDeleteUserFiles(files, (result: any, error: any) => {
            if (error) {
              console.error("Error deleting files:", error);
              return;
            }
            
            setUserFiles((prev) => ({
                ...prev,
                files: prev.files.filter((file) => !files.includes(file.id)),
            }));
          }));
        } catch (e) {
          console.error("Error in onDeleteUserFiles:", e);
        }
    };


    const onPasteExternalImage = (file: File) => {
        setEditorStatus({
            ...editorStatus, 
            currentPicker: "AddNewImage",
            clipBoard:[],
            clipboardExternalImage: file,        
            externalImageLoaded:false    
        });
    }

    const onExternalImageLoaded = () => {
        setEditorStatus({
            ...editorStatus, 
            externalImageLoaded:true
        })
    }

    const loadLastExternalImage = (file: File) => {
        setEditorStatus({
            ...editorStatus,
            clipboardExternalImage: file
        })
    }

    
      
    
    const stageRef = React.useRef<Konva.Stage>(null);

    return (
        <Context.Provider value={{
            stageRef,
            userPermission,
            entityInformation,
            parsedTreeInfo,
            userFiles,
            data,
            artboardsZIndexChain,
            colorPalette,
            selectDescribe,
            dataUndo,
            dataRedo,
            multiEditingConfig,
            editorStatus,
            saveStatus,
            addInsStatus,
            warningStatus,
            selectorActive,
            searchImages,
            onEditEntityInformation: (entityInfo: ITemplate) => onEditEntityInformation(entityInfo),
            onEditUserFiles: (userFiles: IUserFiles) => onEditUserFiles(userFiles),
            onEditUserFilesClose: (userFiles: IUserFiles) => onEditUserFilesClose(userFiles),
            onShowSelectDescribe: (show: boolean)=>onShowSelectDescribe(show),
            onShowDescribedLayerColor: (show: boolean)=>onShowDescribedLayerColor(show),
            onShowPicker: (picker: IPickerType, pickerProperties?: IPickerProperties)=>onShowPicker(picker, pickerProperties),
            onIsPickerFocued: (value: boolean) => onIsPickerFocused(value),
            onShowSearchImages:(show: boolean)=>onShowSearchImages(show),
            onShowSubPicker: (subpicker: ISubPickerType, subPickerProperties?: ISubPickerProperties,selectDescribeFieldId?: string[] )=>onShowSubPicker(subpicker, subPickerProperties, selectDescribeFieldId),
            onSavingParsedTree: (saving: boolean)=>onSavingParsedTree(saving),
            onSelectedElementsIdChange: (id?: string)=>onSelectedElementsIdChange(id),
            onMultiEditingFocus: (selectDescribeFieldId: string[]) => onMultiEditingFocus(selectDescribeFieldId),
            onGroupOpenStatusChange: (id: string) => onGroupOpenStatusChange(id),
            onWarningScreenChange: (open: boolean, title: string, subtitle: string, actionTitle: string, actionFunction: any, closeActionTitle: string, errorNote: string, errorArguments: any, secondaryFunction?: any) => onWarningScreenChange(open, title, subtitle, actionTitle, actionFunction, closeActionTitle, errorNote, errorArguments, secondaryFunction),
            onSelectedSelectDescribeCategoryIdChange: (id?: string)=>onSelectedSelectDescribeCategoryIdChange(id),
            onSelectDescribeCategoryClearAll: (id: string) => onSelectDescribeCategoryClearAll(id),
            onSelectDescribeCategoryAdd: (idCategory: string, categoryName: string) => onSelectDescribeCategoryAdd(idCategory, categoryName),
            onSelectedElementIsEditing: (id?: string, isEditing?: boolean, offsetX?:number, offsetY?:number, height?:number)=> onSelectedElementIsEditing(id, isEditing, offsetX, offsetY, height),
            onSelectedText: (textSelectionInformation: ITextSelectionInformation) => onSelectedText(textSelectionInformation),
            onOverElementIdChange: (id?: string, isOver?: boolean) => onOverElementIdChange(id, isOver),
            onSelectedArtboardChange: (id?: string, selector?: string)=>onSelectedArtboardChange(id, selector),
            onScrolling: (scrollX?:number, scrollY?:number)=> onScrolling(scrollX,scrollY),
            onCommandChange: (command: string, value?: any, ids?: string[], values?: any[], notAutoSave?: boolean, multiEditingMode?: boolean, showSavingMessage?: boolean, commandOrigin?: string)=>onCommandChange(command, value, ids, values, notAutoSave, multiEditingMode, showSavingMessage, commandOrigin),
            onColorAdded: (color: string)=>onColorAdded(color),
            onTemplateCategoryAdded: (parentCategoryId: string, parentCategoryName: string)=>onTemplateCategoryAdded(parentCategoryId, parentCategoryName),
            onTemplateCategoryRemoved: (templateCategoryId: string) => onTemplateCategoryRemoved(templateCategoryId),
            onRotation: (rotation?: number, x?: number, y?: number, offsetX?: number, offsetY?: number)=>onRotation(rotation,x,y,offsetX,offsetY),
            onHandleShift: (value: boolean)=>onHandleShift(value),
            onShowCropImage: (value: boolean, save?:boolean)=>onShowCropImage(value, save),
            onCancelCropImage: ()=>onCancelCropImage(), 
            onUndoRedo: (value: string)=>onUndoRedo(value),
            onSelectorActive: (value: string, ids: string[])=>onSelectorActive(value, ids),
            onExporting:(exporting:boolean, exportingProperties?:IExportingProperties)=> onExporting(exporting, exportingProperties),
            onExportingPropsChange:(exportingProperties?:IExportingProperties)=> onExportingPropsChange(exportingProperties),            
            onExportingCompress: (size?:number, ratio?:number, id?:string)=> onExportingCompress(size, ratio, id),
            onZoomChange: (value: number, point?: string)=>onZoomChange(value, point),
            onDraggingNewElement: (value: boolean)=>onDraggingNewElement(value),
            onDraggingData: (value?: IDraggingData)=>onDraggingData(value),
            onDraggingChange: (value: boolean)=>onDraggingChange(value),
            onSavingPreview: (data:string[], name:string, inmediate?:boolean)=>onSavingPreview(data, name, inmediate),
            onExportArtboardMedia: (data:string[], dealerId:string, collection:string, prefix:string, access_token:string, name:string, overwrite?:boolean, inmediate?:boolean)=> onExportArtboradMedia(data,dealerId,collection,prefix,access_token, name,overwrite, inmediate),
            addUpdatePreviews: ()=> addUpdatePreviews(),
            onUpdateEntityInformation: (value: ITemplate|IDesign)=>onUpdateEntityInformation(value),
            onSelectVersion: (change: IParsedTreeChange) => onSelectVersion(change),
            onSelectEditMode: (edit: boolean) => onSelectEditMode(edit),
            onSelectCurrentVersion: ()=> onSelectCurrentVersion(),
            onRestoreVersion: ()=> onRestoreVersion(),
            onSharing:(sharing:boolean)=> onSharing(sharing),            
            onRefreshStage: (refresh:boolean) => onRefreshStage(refresh),            
            onSetsChange:(set:string)=> onSetsChange(set),
            onShowGridOverlay:(show:boolean)=>onShowGridOverlay(show),
            onChangeGridOverlaySize:(size:number)=>onChangeGridOverlaySize(size),
            onSavePending:(savePending:boolean)=>onSavePending(savePending),
            onDeleteUserFiles: (files: string[] | null) => onDeleteUserFiles(files),
            onPasteExternalImage: (file: File) => onPasteExternalImage(file),
            loadLastExternalImage: (file: File) => loadLastExternalImage(file),
            onExternalImageLoaded: () => onExternalImageLoaded(),            
            //clearExternalImages: () => clearExternalImages(),
        }}>
            {props.children}
        </Context.Provider>
    )
}

export default Provider;